import React from 'react'
import {useNavigate} from 'react-router-dom';

function CoursesCard(props) {
  const { title,category,price,img,rating,teacher,keyPoints}= props

  let star=[1, 2, 3, 4,5]
  let idx = 0
  for (let i = 0; i < Math.floor(rating); i++) {
    star[i]="star"
    idx=i+1
  }
  if (rating%1 !==0) {
    star[Math.floor(rating)]="star-half-outline"
    idx=star.indexOf("star-half-outline")+1
  }

  star.fill("star-outline",idx)
  let navigate= useNavigate();

  return (
    <div>

      <div class="card card-cascade wider m-3 shadow-lg purple darken-4" style={{ width: "300px" } }  onClick={()=>navigate("/onlineCourses/course")} >
        <div className='position-relative p-1 '>

          <img class="card-img-top  " src={require('../../resource/global.webp')} style={{ borderRadius: "20px " }} alt="Card image cap" />
          <div className="d-flex justify-content-between align-items-start mt-1 ">
            <span class="badge badge-pill badge-primar pink darken-4 position-absolut px-2" style={{ bottom: "0", left: "5px" }}>{category}</span>
            <div className="review mb-2">
            {star.map((i)=>{
              return   <ion-icon name={i} style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon> 
            })}
                       </div>

          </div>
        </div>

        <div class="card-body white-2 card-body-cascade d-flex flex-column justify-content-evenly pb-0 ">

          <h4 className=' lime-tex' style={{color:"wheat"}} >{title}</h4>
          <div className='white-3 '>
          {keyPoints.map((keyPoint)=>{
            return  <p > <span style={{ color:"wheat"}}> ✔ </span>{keyPoint}</p>
          })}
          </div>
          <div className="profile d-flex justify-content-around my-1">
            <div className="d-flex align-items-center">
              <img className="p-1" src={require("../../resource/avater.png")} style={{ borderRadius: "50%  ", background: "pink", width: "50px", height: "50px", overflow: "hidden" }} alt="ss" />
              <h6 className=' mx-1'>{teacher}</h6>
            </div>
            <a href="" className="btn white-text teal accent-5">{price}</a>
          </div>

        </div>

      </div>
    </div>
  )
}

export default CoursesCard